import { GoogleAdsConnectorIcon, GoogleAdsWhiteConnectorIcon } from '@/assets';
import { AccountSelection } from '../AccountSelection/AccountSelection';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';

export const GoogleAdsEditConnector = () => {
  return (
    <AccountSelection
      title="Google Ads"
      connectionSteps={FACEBOOK_CONNECTION_STEPS}
      selectedIcon={GoogleAdsWhiteConnectorIcon}
      unselectedIcon={GoogleAdsConnectorIcon}
    />
  );
};
